export var MAX_FILE_SIZE_FOR_PREVIEW = 10e6; // 10 MB

export var LocalFileSource = /*#__PURE__*/function (LocalFileSource) {
  LocalFileSource["PastedFile"] = "pastedFile";
  LocalFileSource["PastedScreenshot"] = "pastedScreenshot";
  LocalFileSource["LocalUpload"] = "localUpload";
  return LocalFileSource;
}({});